// Throwaway / disposable email domains, blocked at sign-up (client, for a
// clear message) and again by the free starter avatar claim (server:
// functions/api/avatar/claim-starter.ts and the disposable_email_domains table
// in 20261027_free_starter_avatar.sql, seeded from this same list).
//
// A compact list of the most common providers, not an exhaustive one. A
// subdomain of a listed domain (x.mailinator.com) counts as listed.

export const DISPOSABLE_EMAIL_DOMAINS: readonly string[] = [
  '0-mail.com', '10minutemail.com', '10minutemail.net', '10minutemail.co.uk', '10minemail.com',
  '20minutemail.com', '20minutemail.it', '33mail.com', '1secmail.com', '1secmail.net', '1secmail.org',
  '2prong.com', '30minutemail.com', '4warding.com', '7tags.com', '9ox.net',
  'anonbox.net', 'anonymbox.com', 'antichef.com', 'antispam.de', 'armyspy.com', 'binkmail.com',
  'bobmail.info', 'bccto.me', 'boximail.com', 'burnermail.io', 'byom.de', 'chacuo.net', 'cool.fr.nf',
  'courriel.fr.nf', 'cuvox.de', 'dayrep.com', 'deadaddress.com', 'despam.it', 'devnullmail.com',
  'dingbone.com', 'discard.email', 'discardmail.com', 'discardmail.de', 'dispostable.com',
  'dodgeit.com', 'dodgit.com', 'dropmail.me', 'dumpmail.de', 'e4ward.com', 'einrot.com',
  'email-fake.com', 'emailfake.com', 'emailinfive.com', 'emailmiser.com', 'emailondeck.com',
  'emailsensei.com', 'emailtemporanea.com', 'emailtemporario.com.br', 'emailwarden.com', 'emailx.at.hm',
  'emailxfer.com', 'emltmp.com', 'fakeinbox.com', 'fakemail.net', 'fakemailgenerator.com',
  'fastacura.com', 'filzmail.com', 'fleckens.hu', 'fizmail.com', 'getairmail.com', 'getnada.com',
  'getonemail.com', 'gishpuppy.com', 'grr.la', 'guerrillamail.biz', 'guerrillamail.com',
  'guerrillamail.de', 'guerrillamail.info', 'guerrillamail.net', 'guerrillamail.org',
  'guerrillamailblock.com', 'gustr.com', 'harakirimail.com', 'hidemail.de', 'hmamail.com',
  'hulapla.de', 'ieatspam.eu', 'ieatspam.info', 'imgof.com', 'incognitomail.com', 'incognitomail.org',
  'inboxalias.com', 'inboxbear.com', 'inboxkitten.com', 'jetable.com', 'jetable.fr.nf', 'jetable.net',
  'jetable.org', 'jourrapide.com', 'kasmail.com', 'kaspop.com', 'killmail.com', 'killmail.net',
  'klzlk.com', 'kurzepost.de', 'letthemeatspam.com', 'linshiyouxiang.net', 'lroid.com', 'mail-temp.com',
  'mail.tm', 'mail7.io', 'mailcatch.com', 'maildrop.cc', 'mailexpire.com', 'mailforspam.com',
  'mailfreeonline.com', 'mailimate.com', 'mailinator.com', 'mailinator.net', 'mailinator.org',
  'mailinator2.com', 'mailmetrash.com', 'mailmoat.com', 'mailnesia.com', 'mailnull.com', 'mailpoof.com',
  'mailsac.com', 'mailshell.com', 'mailtemp.info', 'mailtothis.com', 'mailzi.ru', 'meltmail.com',
  'mintemail.com', 'moakt.com', 'moakt.cc', 'mohmal.com', 'mt2015.com', 'mvrht.com', 'mytemp.email',
  'mytrashmail.com', 'nada.email', 'neverbox.com', 'no-spam.ws', 'nomail.xl.cx', 'nospam.ze.tc',
  'nowmymail.com', 'objectmail.com', 'onewaymail.com', 'owlymail.com', 'pokemail.net', 'proxymail.eu',
  'rcpt.at', 'receiveee.com', 'rhyta.com', 'rmqkr.net', 'safetymail.info', 'sharklasers.com',
  'shieldemail.com', 'shitmail.me', 'smashmail.de', 'snakemail.com', 'sneakemail.com', 'sofort-mail.de',
  'spam4.me', 'spambog.com', 'spambox.us', 'spamdecoy.net', 'spamex.com', 'spamfree24.org',
  'spamgourmet.com', 'spamhole.com', 'spaml.de', 'spammotel.com', 'spamspot.com', 'spamthis.co.uk',
  'superrito.com', 'suremail.info', 'tafmail.com', 'teleworm.us', 'temp-mail.io', 'temp-mail.org',
  'temp-mail.ru', 'tempail.com', 'tempe-mail.com', 'tempemail.co.za', 'tempemail.com', 'tempemail.net',
  'tempinbox.com', 'tempmail.com', 'tempmail.de', 'tempmail.dev', 'tempmail.net', 'tempmail.plus',
  'tempmailaddress.com', 'tempmailo.com', 'tempr.email', 'tempsky.com', 'thankyou2010.com',
  'throwam.com', 'throwawaymail.com', 'tmail.ws', 'tmailinator.com', 'tmpmail.net', 'tmpmail.org',
  'trash-mail.at', 'trash-mail.com', 'trash-mail.de', 'trash2009.com', 'trashmail.at', 'trashmail.com',
  'trashmail.de', 'trashmail.io', 'trashmail.me', 'trashmail.net', 'trashmail.ws', 'trashymail.com',
  'trbvm.com', 'tyldd.com', 'uggsrock.com', 'wegwerfemail.de', 'wegwerfmail.de', 'wegwerfmail.net',
  'wegwerfmail.org', 'wh4f.org', 'yepmail.net', 'yopmail.com', 'yopmail.fr', 'yopmail.net',
  'you-spam.com', 'zetmail.com', 'zippymail.info', 'zoemail.org',
];

const SET = new Set(DISPOSABLE_EMAIL_DOMAINS);

/** The lower-cased domain part of an email address ('' if there isn't one). */
export function emailDomain(email: string): string {
  const at = email.lastIndexOf('@');
  return at < 0 ? '' : email.slice(at + 1).trim().toLowerCase().replace(/\.+$/, '');
}

/** Is this address on a known throwaway domain (or a subdomain of one)? */
export function isDisposableEmail(email: string | null | undefined): boolean {
  const d = emailDomain(email || '');
  if (!d) return false;
  const parts = d.split('.');
  for (let i = 0; i < parts.length - 1; i++) {
    if (SET.has(parts.slice(i).join('.'))) return true;
  }
  return false;
}
